var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTrash = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 3.375L10.3329 10.9641C10.2862 11.6182 9.7419 12.125 9.0861 12.125H3.9139C3.2581 12.125 2.7138 11.6182 2.66708 10.9641L2.125 3.375M5.25 5.875V9.625M7.75 5.875V9.625M8.375 3.375V1.5C8.375 1.15482 8.09518 0.875 7.75 0.875H5.25C4.90482 0.875 4.625 1.15482 4.625 1.5V3.375M1.5 3.375H11.5",
    stroke: "#D12B3F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trash.db8952cc.svg";
export { ForwardRef as ReactComponent };